import axios from 'axios';

const hokakuApiService = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken') || ''}`,
  },
  timeout: process.env.VUE_TIMEOUT||5000,
});

export default hokakuApiService;
